import { ClustersPerBoxComponent } from "app/views/pages/cnc/admin/complaints/clusters-per-box/clusters-per-box.component";
import { BoxesAffected } from "../cnc/admin/models/boxes-affected-model";
import { title } from "process";

export class PageConfig {
    public defaults: any = {
        dashboard: {
            page: {
                title: 'Dashboard',
                desc: 'Fyffes Portal Latest Updates'
            },
        },
        changePassword: {
            page: {
                title: 'User Management',
                desc: 'Change Password'
            },
        },
		home: {
            page: {
                title: 'Home',
                desc: 'Fyffes NA Portal'
            },
        },
        o2c: {
            page: {
                title: 'Dashboard O2C',
                desc: 'Order to Cash Summary'
            },
        },
        administration: {
            page: {
                title: 'Analytics',
                desc: 'Administration of Analytics'
            },
        },
        qcDailyReportSettings: {
            page: {
                title: 'Analytics',
                desc: 'QC Daily Report Settings'
            },
        },
        supplychain: {
            page: {
                title: 'Dashboard Supply Chain',
                desc: 'Dashboard of supply chain'
            },
        },
        operations: {
            page: {
                title: 'Dashboard Operations',
                desc: 'Dashborad of operations'
            },
        },
        /**
         * Subheader Information
         * @author Rosa Korse
         * @since 2019-11-19
         */
        changeEmailMessage: {
            page: {
                title: 'O2C',
                desc: 'Change Email Message'
            },
        },
        salesOrdersPassing: {
            page: {
                title: 'O2C',
                desc: 'Sales Orders Passing'
            },
        },
        unprocessed: {
            page: {
                title: 'O2C',
                desc: 'Invoicing'
            },
        },
        invoicesAddDoc: {
            page: {
                title: 'O2C',
                desc: 'Add Support Docs.'
            },
        },
        invoicesViewDoc: {
            page: {
                title: 'O2C',
                desc: 'View Support Docs.'
            },
        },
        customerAddresses: {
            page: {
                title: 'O2C',
                desc: 'EDI Addresses Information'
            },
        },
        discrepancyTypes: {
            page: {
                title: 'O2C',
                desc: 'Discrepancy Types'
            },
        },
        masterCodes: {
            page: {
                title: 'O2C',
                desc: 'Master Codes'
            },
        },
        productMapping: {
            page: {
                title: 'O2C',
                desc: 'Product Mapping'
            },
        },
        xmlSchemaDocuments: {
            page: {
                title: 'O2C',
                desc: 'XML Schema Docs'
            },
        },
        xmlCustomerMapping: {
            page: {
                title: 'O2C',
                desc: 'XML Customer Mapping'
            },
        },
		providerIntegarions: {
            page: {
                title: 'O2C',
                desc: 'Structure Integration'
            },
        },
        errorMessageMapping: {
            page: {
                title: 'O2C',
                desc: 'Error Message Mapping'
            },
        },
		customerMapping: {
            page: {
                title: 'O2C',
                desc: 'Customer Mappings'
            },
        },
        debitsCredits: {
            page: {
                title: 'O2C',
                desc: 'Debits and Credits'
            },
        },
        supportCreditDoc:
        {
            page: {
                title: 'O2C',
                desc: 'Support Credits Documents'
            },
        },
        purchaseOrders: {
            page: {
                title: 'O2C',
                desc: 'EDI Transaction Management'
            },
        },
        noEDIOrdersList:{
            page: {
                title: 'O2C',
                desc: 'Create Sales Order for No EDI Orders'
            },
        },

        changeSalesOrder: {
            page: {
                title: 'O2C',
                desc: 'Change/Assign PO Number'
            },
		},
         updateSalesOrder: {
            page: {
                title: 'O2C',
                desc: 'Modify Sales Order'
            },
		}, createSalesOrder: {
            page: {
                title: 'O2C',
                desc: 'Create New Sales Order'
            },
		},
		cancelSalesOrder: {
            page: {
                title: 'O2C',
                desc: 'Cancel PO / Sales Order'
            },
		},
        invoice: {
            page: {
                title: 'O2C',
                desc: 'Invoice Search'
            },
        },
        log: {
            page: {
                title: 'O2C',
                desc: 'Document Logs'
            },
        },
        customerStatement: {
            page: {
                title: 'O2C',
                desc: 'Customer Statement'
            },
        },
        ediPoSearch: {
            page: {
                title: 'O2C',
                desc: 'EDI PO Search'
            },
        },
        ediPoDetailReport: {
            page: {
                title: 'O2C',
                desc: 'EDI PO Detail Report'
            },
        },
        messageSearch: {
            page: {
                title: 'O2C',
                desc: 'Message Search'
            },
        },
		saleOrderSearchO2C: {
            page: {
                title: 'O2C',
                desc: 'Sales Order Search'
            },
        },
        salesInventoryDistReport: {
            page: {
                title: 'O2C',
                desc: 'Sales Inventory Dist Report'
            },
        },
        inboundControl: {
            page: {
                title: 'O2C',
                desc: 'Inbound Control'
            },
        },
        agentSettingsTypes: {
            page: {
                title: 'O2C',
                desc: 'Agent Settings Types'
            },
        },
        agentSettingsFields: {
            page: {
                title: 'O2C',
                desc: 'Agent Settings Fields'
            },
        },
        agentSettingsProfiles: {
            page: {
                title: 'O2C',
                desc: 'Agent Settings Profiles'
            },
        },
        outTurn: {
            page: {
                title: 'Operations',
                desc: 'Out Turn'
            },
        },
		containerReport: {
            page: {
                title: 'Operations',
                desc: 'Container Status Report'
            },
        },
		containerSearch: {
            page: {
                title: 'Operations',
                desc: 'Container Search'
            },
        },
		palletContainerSearchMobile: {
            page: {
                title: 'Operations',
                desc: 'Pallet Scan'
            },
        },
        orderReleasesReport: {
            page: {
                title: 'Operations',
                desc: 'Order Releases Report'
            },
        },
		palletContainerSearch: {
            page: {
                title: 'Operations',
                desc: 'Pallet / Container Search'
            },
        },
        harmonizedTariff: {
            page: {
                title: 'Operations',
                desc: 'Harmonized Tariff'
            },
        },
        warehouseContacts: {
            page: {
                title: 'Operations',
                desc: 'Warehouse Contacts'
            },
        },
		warehouseControls: {
            page: {
                title: 'Operations',
                desc: 'Warehouse Controls'
            },
        },
        truckReceipt: {
            page: {
                title: 'Operations',
                desc: 'Truck Receipt'
            },
        },
        confirmationOfSales: {
            page: {
                title: 'Operations',
                desc: 'Confirmation Of Sales'
            },
        },assignWHLocation:{
            page: {
                title: 'Operations',
                desc: 'Assign WH Location'
            },
        },assignDoor:{
            page: {
                title: 'Operations',
                desc: 'Assign Dock Number'
            },
        },
		inInspection:{
            page: {
                title: 'Operations',
                desc: 'Inbound Vehicle Inspection'
            },
        },
		outInspection:{
            page: {
                title: 'Operations',
                desc: 'Outbound Vehicle Inspection'
            },
        },
		warehouseCapacity:{
            page: {
                title: 'Operations',
                desc: 'Warehouse Capacity'
            },
        },
		warehouseDoors:{
            page: {
                title: 'Operations',
                desc: 'Warehouse Doors'
            },
        },
		byPallet:{
			page: {
                title: 'Operations',
                desc: 'By Pallet'
            },
		},
		byContainer:{
			page: {
                title: 'Operations',
                desc: 'By Container'
            },
		},
		byOrder:{
			page: {
                title: 'Operations',
                desc: 'By Order'
            },
		},
		receiveShipment:{
			page: {
                title: 'Operations',
                desc: 'Receive Shipment'
            },
		},
		shipOrder:{
			page: {
                title: 'Operations',
                desc: 'Ship Order'
            },
		},
		warehouseDaily:{
			page: {
                title: 'Operations',
                desc: 'Warehouse Daily Report'
            },
		},
		saleOrderSearchOperations: {
            page: {
                title: 'Operations',
                desc: 'Sales Order Search'
            },
        },
        discrepancyReport: {
            page: {
                title: 'O2C',
                desc: 'EDI Discrepancy Summary'
            },
        },
		warehouseInventory: {
            page: {
                title: 'Operations',
                desc: 'Warehouse Inventory'
            },
        },
		inspectionReport: {
            page: {
                title: 'Operations',
                desc: 'IN/OUT Inspection Report'
            },
        },
		warehouseInventoryReport: {
            page: {
                title: 'Operations',
                desc: 'Warehouse Inventory Report'
            },
        },
		truckerContacts: {
            page: {
                title: 'Operations',
                desc: 'Trucker Contacts'
            },
        },
		mobileApp: {
            page: {
                title: 'Community Apps',
                desc: 'Download Mobile App'
            },
        },
		chatgpt: {
            page: {
                title: 'Community Apps',
                desc: 'FyffesPedia'
            },
        },

        applications: {
            page: {
                title: 'A&A',
                desc: 'Application - Components'
            },
        },
        rolesProfiles: {
            page: {
                title: 'A&A',
                desc: 'Roles - Profiles'
            },
        },
        entityTypes: {
            page: {
                title: 'A&A',
                desc: 'Entity Types'
            },
        },
        appEntityTypes: {
            page: {
                title: 'A&A',
                desc: 'Applications to Entity Types'
            },
        },
        profilesComponents: {
            page: {
                title: 'A&A',
                desc: 'Profiles to Components'
            },
        },
        userEntities: {
            page: {
                title: 'A&A',
                desc: 'User to Entities'
            },
        },
        userRoles: {
            page: {
                title: 'A&A',
                desc: 'User to Roles'
            },
        },
        userComponents: {
            page: {
                title: 'A&A',
                desc: 'Users by Component'
            },
        },
		entities: {
            page: {
                title: 'A&A',
                desc: 'Entities'
            },
        },
        userInquiry: {
            page: {
                title: 'A&A',
                desc: 'By User'
            },
        },
        parametersTypes:
        {
            page: {
                title: 'Parameters',
                desc: 'Parameters'
            },
        },
		vessels: {
            page: {
                title: 'Supply Chain',
                desc: 'Vessels'
            },
        },
		schedule: {
            page: {
                title: 'Supply Chain',
                desc: 'Schedule'
            },
        },
		loadingPorts: {
            page: {
                title: 'Supply Chain',
                desc: 'Loading Ports'
            },
        },
		prebooks: {
            page: {
                title: 'Supply Chain',
                desc: 'Prebooks'
            },
        },
		orders: {
            page: {
                title: 'Supply Chain',
                desc: 'Orders'
            },
        },
		salesVsPrebooks: {
            page: {
                title: 'Supply Chain',
                desc: 'Sales vs Prebooks'
            },
        },
		'5WRV': {
            page: {
                title: 'Supply Chain',
                desc: '7 Weeks Rolling Forecast Vendors'
            },
        },
		MTP: {
            page: {
                title: 'Supply Chain',
                desc: 'MTP'
            },
        },
		prebooksPlans: {
            page: {
                title: 'Supply Chain',
                desc: 'Prebooks Plans'
            },
        },
		orderConsolidation: {
            page: {
                title: 'Supply Chain',
                desc: 'Order Consolidation'
            },
        },
		allocation: {
            page: {
                title: 'Supply Chain',
                desc: 'Allocation'
            },
        },
		containerStripping: {
            page: {
                title: 'Operations',
                desc: 'Container Stripping Times'
            },
        },
        complaintReasons: {
            page: {
                title: 'C&C',
                desc: 'Complaint Subreasons'
            },
        },
        complaintSubreasons: {
            page: {
                title: 'C&C',
                desc: 'Complaint Subreasons'
            },
        },
        complaintTypes: {
            page: {
                title: 'C&C',
                desc: 'Complaint Types'
            },
        },
        boxAffected: {
            page: {
                title: 'C&C',
                desc: 'Unit of Boxes Affected'
            },
        }, 
        clustersPerBox: {
            page: {
                title: 'C&C',
                desc: 'Clusters per Box'
            },
        },
        disposition: {
            page: {
                title: 'C&C',
                desc: 'Disposition'
            },
        },
        complaintReasonSubreason: {
            page: {
                title: 'C&C',
                desc: 'Complaint Reason Subreason'
            },
        },
        complaintReasonTypes:{
            page: {
                title: 'C&C',
                desc: 'Complaint Reason Types'
            },
        },
        complaintReasonDisposition: {
            page: {
                title: 'C&C',
                desc: 'Complaint Reason Disposition'
            },
        },
        createEditComplaints: {
            page: {
                title: 'C&C',
                desc: 'Create/Edit Complaint'
            },
        },
        toDos: {
            page: {
                title: 'C&C',
                desc: 'To-Dos'
            },
        },
        confirmationAddOn: {
            page: {
                title: 'C&C',
                desc: 'Confirmation Add On'
            },
        },
        statusCodes: {
            page: {
                title: 'C&C',
                desc: 'Status Codes'
            },
        },
        processes: {
            page: {
                title: 'C&C',
                desc: 'Processes'
            },
        },
        notifyParties: {
            page: {
                title: 'C&C',
                desc: 'Notify Parties'
            },
        },
        workFlows: {
            page: {
                title: 'C&C',
                desc: 'WorkFlows'
            },
        },
        searchComplaints: {
            page: {
                title: 'C&C',
                desc: 'Complaints Search'
            },
        },
        searchLons: {
            page: {
                title: 'C&C',
                desc: 'Claim Search'
            },
        },
        claimDetailsReport: {
            page: {
                title: 'C&C',
                desc: 'Claim Details'
            },
        },
        complaintOverviewReport: {
            page: {
                title: 'C&C',
                desc: 'Complaint Overview Report'
            }
        },
        customerOpenComplaints: {
            page: {
                title: 'C&C',
                desc: 'Customer Open Complaints'
            },
        },
        toDosReport:{
            page: {
                title: 'C&C',
                desc: 'To Dos Report'
            },
        },
        detailsComplaints: {
            page: {
                title: 'C&C',
                desc: 'Details Complaints'
            },
        },
        claimReasons: {
            page: {
                title: 'C&C',
                desc: 'Claim Reasons'
            },
        },
        vendorEmails: {
            page: {
                title: 'C&C',
                desc: 'Vendors'       
            }
        },
        notificationFormat: {
            page: {
                title: 'C&C',
                desc: 'Notification Format'
            }
        },
        statusCodeClaims: {
            page: {
                title: 'C&C',
                desc: 'Status Codes'
            }
        },
        processClaims: {
            page: {
                title: 'C&C',
                desc: 'Processes'
            }
        },
        notifyPartyClaims: {
            page: {
                title: 'C&C',
                desc: 'Notify Parties'
            }
        },
        workFlowClaims: {
            page: {
                title: 'C&C',
                desc: 'WorkFlows'
            }
        },
        createLon: {
            page: {
                title: 'C&C',
                desc: 'Create/Edit Claims'       
            }
        },
        chargeTypes: {
            page: {
                title: 'C&C',
                desc: 'Charge Types' 
            }
        },
        toDoDelegation: {
            page: {
                title: 'C&C',
                desc: 'ToDo Delegation'
            }
        },
        ngbootstrap: {
            accordion: {
                page: { title: 'Accordion', desc: '' }
            },
            alert: {
                page: { title: 'Alert', desc: '' }
            },
            buttons: {
                page: { title: 'Buttons', desc: '' }
            },
            carousel: {
                page: { title: 'Carousel', desc: '' }
            },
            collapse: {
                page: { title: 'Collapse', desc: '' }
            },
            datepicker: {
                page: { title: 'Datepicker', desc: '' }
            },
            dropdown: {
                page: { title: 'Dropdown', desc: '' }
            },
            modal: {
                page: { title: 'Modal', desc: '' }
            },
            pagination: {
                page: { title: 'Pagination', desc: '' }
            },
            popover: {
                page: { title: 'Popover', desc: '' }
            },
            progressbar: {
                page: { title: 'Progressbar', desc: '' }
            },
            rating: {
                page: { title: 'Rating', desc: '' }
            },
            tabs: {
                page: { title: 'Tabs', desc: '' }
            },
            timepicker: {
                page: { title: 'Timepicker', desc: '' }
            },
            tooltip: {
                page: { title: 'Tooltip', desc: '' }
            },
            typehead: {
                page: { title: 'Typehead', desc: '' }
            }
        },
        material: {
            // form controls
            'form-controls': {
                autocomplete: {
                    page: { title: 'Auto Complete', desc: '' }
                },
                checkbox: {
                    page: { title: 'Checkbox', desc: '' }
                },
                datepicker: {
                    page: { title: 'Datepicker', desc: '' }
                },
                radiobutton: {
                    page: { title: 'Radio Button', desc: '' }
                },
                formfield: {
                    page: { title: 'Form field', desc: '' }
                },
                input: {
                    page: { title: 'Input', desc: '' }
                },
                select: {
                    page: { title: 'Select', desc: '' }
                },
                slider: {
                    page: { title: 'Slider', desc: '' }
                },
                slidertoggle: {
                    page: { title: 'Slider Toggle', desc: '' }
                }
            },
            // navigation
            navigation: {
                menu: {
                    page: { title: 'Menu', desc: '' }
                },
                sidenav: {
                    page: { title: 'Sidenav', desc: '' }
                },
                toolbar: {
                    page: { title: 'Toolbar', desc: '' }
                }
            },
            // layout
            layout: {
                card: {
                    page: { title: 'Card', desc: '' }
                },
                divider: {
                    page: { title: 'Divider', desc: '' }
                },
                'expansion-panel': {
                    page: { title: 'Expansion panel', desc: '' }
                },
                'grid-list': {
                    page: { title: 'Grid list', desc: '' }
                },
                list: {
                    page: { title: 'List', desc: '' }
                },
                tabs: {
                    page: { title: 'Tabs', desc: '' }
                },
                stepper: {
                    page: { title: 'Stepper', desc: '' }
                },
                'default-forms': {
                    page: { title: 'Default Forms', desc: '' }
                },
                tree: {
                    page: { title: 'Tree', desc: '' }
                },
            },
            // buttons & indicators
            'buttons-and-indicators': {
                button: {
                    page: { title: 'Button', desc: '' }
                },
                'button-toggle': {
                    page: { title: 'Button toggle', desc: '' }
                },
                chips: {
                    page: { title: 'Chips', desc: '' }
                },
                icon: {
                    page: { title: 'Icon', desc: '' }
                },
                'progress-bar': {
                    page: { title: 'Progress bar', desc: '' }
                },
                'progress-spinner': {
                    page: { title: 'Progress spinner', desc: '' }
                }
            },
            // popups & models
            'popups-and-modals': {
                'bottom-sheet': {
                    page: { title: 'Bottom sheet', desc: '' }
                },
                dialog: {
                    page: { title: 'Dialog', desc: '' }
                },
                snackbar: {
                    page: { title: 'Snackbar', desc: '' }
                },
                tooltip: {
                    page: { title: 'Tooltip', desc: '' }
                }
            },
            // Data tables
            'data-table': {
                paginator: {
                    page: { title: 'Paginator', desc: '' }
                },
                'sort-header': {
                    page: { title: 'Sort header', desc: '' }
                },
                table: {
                    page: { title: 'Table', desc: '' }
                }
            }
        },
        forms: {
            page: { title: 'Forms', desc: '' }
        },
        mail: {
            page: { title: 'Mail', desc: 'Mail' }
        },
        ecommerce: {
            customers: {
                page: { title: 'Customers', desc: '' }
            },
            products: {
                edit: {
                    page: { title: 'Edit product', desc: '' }
                },
                add: {
                    page: { title: 'Create product', desc: '' }
                }
            },
            orders: {
                page: { title: 'Orders', desc: '' }
            }
        },
        'user-management': {
            users: {
                page: { title: 'Users', desc: '' }
            },
            roles: {
                page: { title: 'Roles', desc: '' }
            }
        },
        builder: {
            page: { title: 'Layout Builder', desc: '' }
        },
        header: {
            actions: {
                page: { title: 'Actions', desc: 'Actions example page' }
            }
        },
        profile: {
            page: { title: 'User Profile', desc: '' }
        },
        error: {
            404: {
                page: { title: '404 Not Found', desc: '', subheader: false }
            },
            403: {
                page: { title: '403 Access Forbidden', desc: '', subheader: false }
            }
        },
        wizard: {
            'wizard-1': { page: { title: 'Wizard 1', desc: '' } },
            'wizard-2': { page: { title: 'Wizard 2', desc: '' } },
            'wizard-3': { page: { title: 'Wizard 3', desc: '' } },
            'wizard-4': { page: { title: 'Wizard 4', desc: '' } },
        },
    };

    public get configs(): any {
        return this.defaults;
    }
}
